import { medtechApi } from './index';

const collaboratorsApi = {
  async updateCollaborators(
    companyId: number,
    eventId: number,
    collaborators: number[],
    comment: string,
  ): Promise<void> {
    await medtechApi.patch(`/quality-events/${companyId}/issues/${eventId}/collaborators`, {
      collaborators,
      comment,
    });
  },
};

export default collaboratorsApi;
